
import React from 'react';
import Cal, { getCalApi } from "@calcom/embed-react";
import { useEffect } from "react";

export default function CalBooking() {
  useEffect(() => {
    (async function () {
      try {
        const cal = await getCalApi({"namespace":"arishpvenq"});
        cal("ui", {
          "cssVarsPerTheme": {
            "light": {
              "cal-brand": "#9b87f5",
              "cal-background": "#0a0a0a",
              "cal-text": "#ffffff"
            },
            "dark": {
              "cal-brand": "#9b87f5", 
              "cal-background": "#0a0a0a",
              "cal-text": "#ffffff"
            }
          },
          "hideEventTypeDetails": false,
          "layout": "month_view"
        });
      } catch (error) {
        console.error("Error initializing Cal:", error);
      }
    })();
  }, []);

  // Add scroll behavior when component mounts if hash is #booking
  useEffect(() => {
    if (window.location.hash === '#booking') {
      const timer = setTimeout(() => {
        const element = document.getElementById('booking');
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 500); // Longer delay to ensure Cal component is fully loaded
      
      return () => clearTimeout(timer);
    }
  }, []);

  return (
    <section id="booking" className="py-16 relative">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-[90vw] aspect-square bg-[#9b87f5] opacity-10 rounded-full blur-[100px] md:blur-[150px] md:max-w-[500px]"></div>
      
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-white mb-4 glow-text">Book a Call with Me</h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Schedule a personalized call to discuss how AI can transform your business.
          </p>
        </div>
        
        <div className="max-w-4xl mx-auto">
          <div className="rounded-lg overflow-hidden bg-[#0a0a0a]/30 backdrop-blur-sm p-4 min-h-[650px]">
            <Cal 
              namespace="arishpvenq"
              calLink="aramai/arishpvenq"
              style={{width:"100%", height:"650px", overflow:"auto", backgroundColor:"#0a0a0a"}}
              config={{
                layout: "month_view",
                hideEventTypeDetails: "false",
                theme: "dark"
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
